import { DatiDepositoDTO } from "./dati-deposito-dto";

export class CostituzioneDepositoVolontarioDTO {
	datiDeposito: DatiDepositoDTO;
}